import { createSelector } from 'reselect';
import { defaultTabPriority } from 'features/settings/organize/constants';
import { organizeTabs } from 'features/settings/organize/utils';
import { isUnlocked } from 'features/premium/isUnlocked';
import { Tier } from 'features/premium/entities';
import { selectNavigatorConfig } from '../selectors';
export const selectTabsPriority = createSelector([
    (state) => isUnlocked(state.user?.user, Tier.pro),
    (store) => store.deviceSettings?.tabsPersonalization,
    selectNavigatorConfig,
], (canOrganizeTabs, tabsPersonalization, navConfig) => {
    let visibleTabs = { ...defaultTabPriority };
    if (canOrganizeTabs) {
        visibleTabs = { ...visibleTabs, ...tabsPersonalization };
    }
    //GB
    if (!navConfig.showSaveTab)
        delete visibleTabs.save;
    if (!navConfig.showPayTab)
        delete visibleTabs.pay;
    if (!navConfig.showInvestTab)
        delete visibleTabs.invest;
    if (!navConfig.showBorrowTab)
        delete visibleTabs.borrow;
    // US_CA
    if (!navConfig.showNetworthTab)
        delete visibleTabs.networth;
    if (!navConfig.showBudgetingTab)
        delete visibleTabs.budgeting;
    if (!navConfig.showRecurringTab)
        delete visibleTabs.recurring;
    if (!navConfig.showGroupTab)
        delete visibleTabs.groups;
    // @ts-ignore remove deprecated tab from users preferences
    delete visibleTabs.upgrade;
    const organizedTabs = organizeTabs(visibleTabs);
    return {
        ...organizedTabs,
        hideTabNavigation: organizedTabs.priority.length === 0,
    };
});
